"use client";
import { useModalCustomerContext } from "@/context/CustomerContext";
import { useTranslations } from "next-intl";
import Image from "next/image";

export default function ShopByCate() {
	const { isCustomerModalOpen, openModalCustomer } = useModalCustomerContext();

	const t = useTranslations("");
	const dataList = [
		{
			img: "/image/home/t1.svg",
			svg: "",
			title: t("home.w1"),
			des: t("home.wd1"),
		},
		{
			img: "/image/home/t2.svg",
			title: t("home.w2"),
			des: t("home.wd2"),
		},
		{
			img: "/image/home/t3.svg",
			title: t("home.w3"),
			des: t("home.wd3"),
		},
		{
			img: "/image/home/t4.svg",
			title: t("home.w4"),
			des: t("home.wd4"),
		},
	];

	return (
		<div>
			<div className="container mt-[90px] flex flex-col max-md:mt-[45px]">
				<div className="mb-[110px] flex flex-wrap items-center justify-center gap-x-[40px] gap-y-[50px] max-md:mb-[50px] max-md:flex-col max-md:gap-[30px]">
					{dataList.map((item) => {
						return (
							<div
								className="flex h-[150px] w-[calc(50%-20px)] max-w-[330px] flex-col items-center justify-center max-md:w-[280px] max-sm:w-full"
								key={item.title}
							>
								<Image src={item.img} alt="" width={50} height={50} className="mb-[30px] max-md:mb-[20px]" />
								<p className="mb-[10px] text-[20px] font-bold max-md:text-[18px]">{item.title}</p>
								<p className="min-h-[44px] max-w-[280px] text-center max-md:min-h-[auto] max-md:text-[14px]">
									{item.des}
								</p>
							</div>
						);
					})}
				</div>
				<div className="flex justify-center">
					<button
						onClick={openModalCustomer}
						className="mb-[70px] h-[35px] w-[115px] rounded-sm border-[1px] border-main bg-main text-[16px] text-white transition-all duration-300 hover:!text-black max-md:mb-[40px]"
					>
						<p className="font-bold">{t("home.Live Chat")}</p>
					</button>
				</div>
			</div>
		</div>
	);
}
